<template>
  <div>{{ updateRoute }}</div>
</template>
<script>
import userMixin from "@/mixins/userMixin"
import { mapGetters } from "vuex"

export default {
  mixins: [userMixin],
  computed: {
    ...mapGetters("globals", {
      menteeId: "getMenteeId",
      userMode: "getUserMode"
    }),
    ...mapGetters("users", {
      me: "getMe"
    }),
    updateRoute() {
      if (this.userMode === "MANAGE") {
        this.$router.push({
          name: "dashboardManager"
        })
      } else if (this.userMode === "MENTOR" && this.menteeId > 0) {
        this.$router.push({
          name: "dashboardMentor",
          params: { id: this.menteeId }
        })
      } else if (this.userMode === "MENTEE" && this.me) {
        this.$router.push({
          name: "dashboardMentee",
          params: { id: this.me.id }
        })
      }
    }
  }
}
</script>
